// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../fe-workerportal/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-5222ecb3] .stickyTable thead{display:none}[data-v-5222ecb3] .stickyTable tr{background-color:initial!important}[data-v-5222ecb3] .stickyTable tr td{border:1px solid #dee2e6}", ""]);
// Exports
module.exports = exports;
